import type { GlossaryProps } from "@op/puck-types";
import {
  makeGlossaryItemDefinitionId,
  makeGlossaryItemId,
  useContent,
  useTranslation,
} from "@op/utils";

const Glossary = (_: GlossaryProps) => {
  const { glossaryItems } = useContent();
  const { glossary: glossaryTrans } = useTranslation();

  if (glossaryItems.length === 0) return null;
  return (
    <div
      id="glossary"
      className="glossary-print flex flex-col gap-4"
      style={{ breakBefore: "page" }}
    >
      <h2 className="text-heading-2 font-heading-2 text-default-font">
        {glossaryTrans.glossary}
      </h2>
      <ul className="flex flex-col gap-2">
        {glossaryItems.map((item, index) => (
          <li key={index} id={makeGlossaryItemDefinitionId(item.id)}>
            <a
              href={`#${makeGlossaryItemId(item.id)}`}
              className="text-body font-body text-default-font"
            >
              <strong>{item.term}</strong> - {item.definition}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Glossary;
